@if (code === 'withdraw') {
  <app-app-withdraw-table-individual-info></app-app-withdraw-table-individual-info>
}
